import { ApiService } from "../api.service";
import {
  StorageRowInsert,
  StorageRowInsertContainer,
} from "@/models/entities/storage/storageInput/storageRowInsert.interface";

import {
  // RequireKitRequest,
  RequireKitResponse,
} from "@/models/entities/storage/cart/cartKit.interface";

import { StorageRowInsertResponse } from "@/models/entities/storage/storageInput/storageRowInsertResponse.interface";

const CONTROLLER = "cart";

class CartService extends ApiService {
  addOrder(
    values: StorageRowInsert[],
    notes: string,
    kitSelected: boolean,
    kitNumber: string
  ) {
    const container: StorageRowInsertContainer = {
      elements: values,
      notes: notes,
      kitSelected: kitSelected,
      kitNumber: kitNumber,
    };
    return this.post<StorageRowInsertContainer, StorageRowInsertResponse>(
      `${CONTROLLER}/add`,
      container
    );
  }

  requireKit(values: Array<string[]>) {
    return this.post<Array<string[]>, RequireKitResponse>(
      `${CONTROLLER}/kit`,
      values
    );
  }
}

export const cartService = new CartService();
